export const groupBlocks = ['block', 'root', 'link', 'advanced-animation-block', 'advanced-background-block', 'advanced-scroll-block', 'advanced-stripe'];

export const nestedBlocks = ['advanced-animation-block', 'advanced-scroll-block'];
